import { createSlice } from '@reduxjs/toolkit';
import { api } from '../../api/admin';
import TableUtils from '../../utils/TableUtils';
import StoreUtils from '../../utils/StoreUtils';

const apiPath = "mapGroup";

// Slice
const slice = createSlice({
  name: 'mapGroup',
  initialState: {
    rows: null,
    isLoading: false,
    error: false,
  },
  reducers: {
    startLoading: state => {
      state.isLoading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    rowsSuccess: (state, action) => {
      state.rows = action.payload;
      state.isLoading = false;
    }
  },
});

export default slice.reducer;

// Actions

const { startLoading, hasError, rowsSuccess } = slice.actions;

export const fetchMapGroups = () => async dispatch => {
  dispatch(startLoading());
  try {
    await api.get(`${apiPath}`).then((response) => {
      const rows = TableUtils.sortArrayByString(response.data, 'title');
      dispatch(rowsSuccess(rows));
    });
  }
  catch (e) {
    dispatch(StoreUtils.handleError(e, hasError));
  }
};